import React from 'react';
import { Table, Button, Badge } from 'react-bootstrap';

export default function QueueTable({ queue, onRemove, onSkip }) {
  if (!queue || queue.length === 0) {
    return <p className="text-muted">Queue ist leer.</p>;
  }

  const sourceLabel = (src) => {
    if (src === 'chat_command') return <Badge bg="primary">Chat</Badge>;
    if (src === 'channel_points') return <Badge bg="warning" text="dark">Channel Points</Badge>;
    return <Badge bg="secondary">Manuell</Badge>;
  };

  return (
    <div>
      {onSkip && (
        <Button variant="outline-warning" size="sm" className="mb-3" onClick={onSkip}>
          ⏭ Aktuellen Song skippen
        </Button>
      )}
      <Table variant="dark" striped bordered hover responsive>
        <thead>
          <tr>
            <th>#</th>
            <th>Titel</th>
            <th>Künstler</th>
            <th>Angefragt von</th>
            <th>Quelle</th>
            {onRemove && <th></th>}
          </tr>
        </thead>
        <tbody>
          {queue.map((item, idx) => (
            <tr key={item.id}>
              <td>{idx + 1}</td>
              <td>
                <div className="d-flex align-items-center gap-2">
                  {item.cover_url && (
                    <img
                      src={item.cover_url}
                      alt=""
                      style={{ width: 32, height: 32, borderRadius: 4 }}
                    />
                  )}
                  {item.title}
                </div>
              </td>
              <td>{item.artist}</td>
              <td>{item.requester_name}</td>
              <td>{sourceLabel(item.source)}</td>
              {onRemove && (
                <td>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => onRemove(item.id)}
                  >
                    ✕
                  </Button>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
